export const actiontype={
    AddAssignClick:"AddAssignClick",
    UpdateUserId:'UpdateUserId',
    UpdateUName:'UpdateUName',
    UpdateUserTypeName:'UpdateUserTypeName',
    UpdateUserType:'UpdateUserType',
    UpdatecurrentUser:'UpdatecurrentUser',
    UpdateSession:'UpdateSession'
  
}